module.exports = __webpack_public_path__ + "static/img/resume-cv-classique.3666a8c.png";